/**
 * Misc code
 **/
app.add({

    init: function(){
    },
    
    onCartLoad: function(app){
        var totalItems = app.cart.count();
        if (totalItems === 0) {
            $('[data-product-name="24x36” Wall Posters"]').find('.plus').trigger('click');
        }
    },
    
});


// WEBPACK FOOTER //
// ./resources/assets/js/modules/misc.js